export default {
	lot_id: "",
	primary_first: "",
	primary_last: "",
	primary_email: "",
	co_first: "",
	co_last: "",
	has_co: true,
	reserve_start_date: "",
	reserve_end_date: "",
	buyer_id: ""
}